module.exports = __webpack_public_path__ + "fonts/c342851.eot";